import React from "react";

type ToothSelectorProps = {
  toothNumbers: string[];
  onToothClick: (tooth: number) => void;
};

const upperTeethA = [18, 17, 16, 15, 14, 13, 12, 11];
const upperTeethB = [21, 22, 23, 24, 25, 26, 27, 28];
const lowerTeethA = [48, 47, 46, 45, 44, 43, 42, 41];
const lowerTeethB = [31, 32, 33, 34, 35, 36, 37, 38];

const ToothSelector: React.FC<ToothSelectorProps> = ({
  toothNumbers,
  onToothClick,
}) => {
  const renderRow = (teeth: number[]) => (
    <div className="flex w-full items-center justify-evenly gap-0.5 py-0.5">
      {teeth.map((tooth) => {
        const selected = toothNumbers.includes(tooth.toString());
        return (
          <button
            key={tooth}
            type="button"
            onClick={() => onToothClick(tooth)}
            aria-pressed={selected}
            className={`flex h-6 w-6 items-center justify-center rounded-md text-[9px] font-medium transition-colors md:h-7 md:w-7 md:text-[10px] ${
              selected
                ? "bg-[var(--cu-accent)] text-white"
                : "bg-[var(--cu-input)] text-[var(--cu-muted)] hover:bg-[var(--cu-elevated)] hover:text-[var(--cu-text)]"
            }`}
          >
            {tooth}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className="rounded-lg border border-[var(--cu-border)] bg-[var(--cu-input)] p-2">
      <div className="flex flex-col md:flex-row">
        {renderRow(upperTeethA)}
        <div className="mx-auto my-1 h-px w-8 bg-[var(--cu-border)] md:mx-1.5 md:my-0 md:h-auto md:w-px" />
        {renderRow(upperTeethB)}
      </div>
      <div className="my-1.5 h-px bg-[var(--cu-border)]" />
      <div className="flex flex-col md:flex-row">
        {renderRow(lowerTeethA)}
        <div className="mx-auto my-1 h-px w-8 bg-[var(--cu-border)] md:mx-1.5 md:my-0 md:h-auto md:w-px" />
        {renderRow(lowerTeethB)}
      </div>
      {toothNumbers.length > 0 && (
        <p className="mt-1.5 text-center text-[11px] text-[var(--cu-subtle)]">
          {toothNumbers.length} selected
        </p>
      )}
    </div>
  );
};

export default ToothSelector;
